module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newFirm":"New Firm"},"fr":{"newFirm":"Nouveau firm"}}')
  delete Component.options._Ctor
}
